export const HostAvailability = Object.freeze({
  CHECKING: "checking",
  AVAILABLE: "available",
  OFFLINE: "offline",
  FAILED: "failed",
});

// Backend reports an unreachable host as "User not found" / "... offline".
const OFFLINE_ERROR_PATTERN = /offline|not found|user/i;

export const isHostOfflineError = (error) =>
  typeof error === "string" && OFFLINE_ERROR_PATTERN.test(error);

/**
 * Single source of truth for whether the guest can chat right now.
 * The chat is only "checking" until the host either answers (history
 * loaded) or refuses (offline / failure) — nothing else should block UI.
 */
export const getHostAvailability = ({
  connectionStatus,
  historyLoaded,
  historyError,
}) => {
  if (historyError) {
    return isHostOfflineError(historyError)
      ? HostAvailability.OFFLINE
      : HostAvailability.FAILED;
  }
  if (connectionStatus === "error") return HostAvailability.FAILED;
  if (historyLoaded) return HostAvailability.AVAILABLE;
  return HostAvailability.CHECKING;
};
